import gql from 'graphql-tag';

export const START_GDRIVE_SYNC_MUTATION = gql`
  mutation StartGDriveSyncMutation {
    taskId: startSyncClientToDriveTask
  }
`;
